<template>
  <button
    class="onboarding-btn-container"
    :class="type"
    @click="clickBtn"
    :style="{ width: width ? `${width}px` : '', height: height ? `${height}px` : '' }"
    v-on="$listeners"
    v-bind="$attrs"
  >
    <span v-if="text">{{ text }}</span>
    <slot name="content"></slot>
  </button>
</template>
<script>
export default {
  name: 'OnboardingBtn',
  props: {
    width: Number,
    height: Number,
    text: String,
    type: String,
  },
  methods: {
    clickBtn() {
      this.$emit('clickBtn');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../styles/index.scss';
@import '@/assets/css/mixins.scss';
.onboarding-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 184px;
  height: 44px;
  border-radius: 100px;
  background: linear-gradient(90deg, #ffba52 0%, #f5563c 100%);
  color: #1a1c20;
  font-weight: 500;
  cursor: pointer;
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  &.plain {
    @include gradient-button(
      linear-gradient(to right, #ffba52, #f5563c),
      linear-gradient(to bottom, #191c20, #191c20),
      1px,
      999px
    );
  }
}
</style>
